import React from 'react';
import './spinner'

const Spinner = () => {

    return (
        <div className="spinner"><img src='https://media3.giphy.com/media/3oEjI6SIIHBdRxXI40/giphy.gif' alt='Loading, please wait...'/></div>
    )
}

export default Spinner;